module.exports = __webpack_public_path__ + "img/Clusters._Blue_Circle.f54ce327.png";